import {
  get, max, maxBy, castArray,
} from 'lodash';

const updateYAxisMaxPercentage = ({ options, unit }) => {
  if (!(options)) { return; }
  if (unit === '%') {
    let maxValue: any = null;
    const series = get(options, 'series', []).slice(0);
    const maxItems = series.map((item) => {
      const data = castArray(item.data);
      if (data.length) {
        return maxBy(data, d => d[1])[1];
      }
      return 0;
    });
    maxValue = max(maxItems);
    const settings: any = {};
    if (maxValue >= 90 && maxValue <= 100) {
      settings.max = 100;
      settings.maxInterval = 25;
      settings.splitNumber = 4;

      const axis = options.yAxis;
      if (axis) {
        axis.max = settings.max;
        axis.maxInterval = settings.maxInterval;
        axis.splitNumber = settings.splitNumber;
      }
    }
  }
};

export default updateYAxisMaxPercentage;
